<template>
  <div class="checkout-flow-item order-details">
    <div class="checkout-flow-item-header">
      <h2 v-text="$t('step-flow-cart-details-title')"></h2>
    </div>
    <div class="checkout-flow-item-content" ref="scroll-container">
      <div class="order-options-notice rtf-note" v-if="orderOptionsNotice && orderOptionsNotice.length > 0"
        v-safe-html="orderOptionsNotice"></div>

      <ion-button class="toggle-billing-address" fill="clear" size="small"
        v-if="!cartService.needsBillingAddress.value && cartService.allowedToAddBillingAddress.value"
        @click="cartService.userSuppliesBillingAddress.value = !cartService.userSuppliesBillingAddress.value">
        <span class="label">{{ cartService.userSuppliesBillingAddress.value ?
          $t("step-flow-cart-details-remove-billing-address-button-label") :
          $t("step-flow-cart-details-add-billing-address-button-label") }}</span>
      </ion-button>
      
      <section class="contact-details step-section"
        v-if="company.sendSMSOnOrderReady || pointofsale.collectPhoneNumber || pointofsale.collectCustomerName || showBillingAddress || shouldCollectAnEmailAdress">

        <OidoAddressInput v-if="showBillingAddress" :label="$t('step-flow-cart-details-billing-address-label')"
          :errors="errors.billingAddress" v-model="cartService.billingAddress.value"></OidoAddressInput>

        <oido-phone-input v-if="company.sendSMSOnOrderReady || pointofsale.collectPhoneNumber"
          :label="$t('step-flow-cart-details-phone-input-label')" v-model="cartService.phone.value"
          :errors="errors.phone"
          :default-country="company && company.country ? ('' + company.country).toUpperCase() : 'ES'"></oido-phone-input>

        <div class="input-line" v-if="pointofsale.collectCustomerName">
          <div class="validation-errors" role="alert" v-if="errors && errors.customerName">
            <span class="validation-error" v-for="error of errors.customerName" v-text="error" :key="error"></span>
          </div>
          <ion-item lines="full">
            <ion-input :label="$t('step-flow-cart-details-customer-name-label')" label-placement="floating"
              name="street" type="text" v-model="cartService.customerName.value"
              :aria-invalid="errors && errors.customerName ? 'true' : null" :class="{
                'has-errors': errors && (errors.customerName || errors.global),
              }" />
          </ion-item>
        </div>

        <div class="input-line" v-if="shouldCollectAnEmailAdress">
          <div class="validation-errors" role="alert" v-if="errors && errors.email">
            <span class="validation-error" v-for="error of errors.email" v-text="error" :key="error"></span>
          </div>
          <ion-item lines="full">
            <ion-input :label="$t('step-flow-cart-details-email-label')" label-placement="floating"
              name="street" type="email" v-model="cartService.email.value"
              :aria-invalid="errors && errors.email ? 'true' : null" :class="{
                'has-errors': errors && (errors.email || errors.global),
              }" />
          </ion-item>
        </div>

      </section>


      <section class="choose-details step-section"
        v-if="availableDeliveryOptions && availableDeliveryOptions.length > 1">

        <ion-radio-group class="delivery-type-group" v-model="cartService.deliveryType.value"
          aria-labelledby="delivery-type-group-label">
          <ion-list-header>
            <ion-label id="delivery-type-group-label" v-text="$t('step-flow-cart-details-delivery-type-label')"></ion-label>
          </ion-list-header>

          <ion-item lines="full" v-if="pointofsale.enableTableService">
            <ion-radio mode="md" slot="start" value="table" label-placement="end" :alignment="'center'" justify="start"
              v-text="$t('step-flow-cart-details-is-table-label')"></ion-radio>
          </ion-item>

          <ion-item lines="full" v-if="pointofsale.enablePickup">
            <ion-radio mode="md" slot="start" value="takeaway" label-placement="end" :alignment="'center'"
              justify="start" v-text="$t('step-flow-cart-details-is-takeaway-label')"></ion-radio>
          </ion-item>

          <ion-item lines="full" v-if="pointofsale.enableDelivery">
            <ion-radio mode="md" slot="start" value="delivery" label-placement="end" :alignment="'center'"
              justify="start" v-text="$t('step-flow-cart-details-is-delivery-label')"></ion-radio>
          </ion-item>
        </ion-radio-group>
      </section>


      <section
        v-if="cartService.deliveryType.value == 'delivery' && !(false && customer && customer.userMustNotEditAddresses)"
        class="details-section delivery  step-section delivery-address-section  ">

        <ion-item lines="none" v-if="showBillingAddress">
          <ion-checkbox slot="start" @update:modelValue="cartService.deliveryUsesDifferentAddress.value = $event"
            :modelValue="cartService.deliveryUsesDifferentAddress.value" name="deliveryUsesDifferentAddress"
            labelPlacement="end"
            v-text="$t('step-flow-cart-details-use-different-delivery-address-label')"></ion-checkbox>
        </ion-item>

        <OidoAddressInput :errors="errors.deliveryAddress" class="delivery-address-input" :hide-type-selector="true"
          v-if="!showBillingAddress || cartService.deliveryUsesDifferentAddress.value"
          :label="$t('step-flow-cart-details-delivery-address-header')" :is-delivery-address="true"
          v-model="cartService.deliveryAddress.value"></OidoAddressInput>          
      </section>

      <div class="no-delivery-possible-warning" v-if="deliveryAddressIsComplete && isDelivery && !deliveryIsPossible"
        v-text="$t('step-flow-cart-details-delivery-not-possible-error')"></div>

      <section class="details-section delivery-method-section step-section"
        v-if="isDelivery && applicableDeliveryZones.length > 1">
        <h2 class="step-section-header" v-text="$t('step-flow-cart-details-delivery-method-header')"></h2>

        <ion-radio-group :modelValue="selectedDeliveryZoneId" @update:modelValue="selectDeliveryZone"
          :aria-label="$t('step-flow-cart-details-delivery-method-header')">
          <ion-item lines="none" v-for="zoneEntry of applicableDeliveryZones" :key="zoneEntry.zone.id">
            <ion-radio mode="md" slot="start" :value="zoneEntry.zone.id" label-placement="end" :alignment="'center'"
              justify="start">
              <span class="delivery-method-option">
                <span class="delivery-method-name"
                  v-text="services.translations.translation2Text(zoneEntry.zone.name)"></span>
                <span class="delivery-method-costs" v-if="zonePrice(zoneEntry) !== null">{{
                  zonePrice(zoneEntry).toFixed(2) }}<span class="currency-symbol"
                    v-text="currencySymbol"></span></span>
              </span>
            </ion-radio>
          </ion-item>
        </ion-radio-group>
      </section>

      <section class="details-section pickup-location-section step-section"
        v-if="isPickup && pickupLocations.length > 0">
        <h2 class="step-section-header" v-text="$t('step-flow-cart-details-pickup-location-header')"></h2>

        <ion-radio-group v-if="pickupLocations.length > 1" :modelValue="selectedPickupLocationId"
          @update:modelValue="selectPickupLocation" :aria-label="$t('step-flow-cart-details-pickup-location-header')">
          <ion-item lines="none" v-for="pickupLocation of pickupLocations" :key="pickupLocation.id">
            <ion-radio mode="md" slot="start" :value="pickupLocation.id" label-placement="end" :alignment="'center'"
              justify="start">
              <span class="pickup-location-option">
                <span class="pickup-location-name"
                  v-text="services.translations.translation2Text(pickupLocation.name)"></span>
                <span class="pickup-location-address" v-if="locationAddressLabel(pickupLocation)"
                  v-text="locationAddressLabel(pickupLocation)"></span>
                <span class="pickup-location-description" v-if="locationDescription(pickupLocation)"
                  v-text="locationDescription(pickupLocation)"></span>
              </span>
            </ion-radio>
          </ion-item>
        </ion-radio-group>

        <!-- a single pickup location is shown as read-only info -->
        <div class="pickup-location-summary" v-if="pickupLocations.length == 1 && chosenPickupLocation">
          <span class="pickup-location-name"
            v-text="services.translations.translation2Text(chosenPickupLocation.name)"></span>
          <span class="pickup-location-address" v-if="locationAddressLabel(chosenPickupLocation)"
            v-text="locationAddressLabel(chosenPickupLocation)"></span>
          <span class="pickup-location-description" v-if="locationDescription(chosenPickupLocation)"
            v-text="locationDescription(chosenPickupLocation)"></span>
        </div>

        <!-- a location without a time selection hides the whole time section below:
             without this the customer would never get to see a pickup date at all -->
        <div class="first-possible-pickup-notice" v-if="showFirstPossiblePickupNotice">
          <span class="label" v-text="$t('checkout-details-first-possible-pickup-label')"></span>
          <span class="value" v-text="firstPossiblePickupDateLabel"></span>
        </div>
      </section>

      <delivery-upgrade-hint></delivery-upgrade-hint>

      <section v-if="
        (cartService.deliveryType.value == 'takeaway' && allowCustomPickupTime) ||
        (cartService.deliveryType.value == 'delivery' && allowCustomDeliveryTime)"
        class="details-section takeaway step-section">

        <h2 class="step-section-header" v-if="cartService.deliveryType.value == 'takeaway'"
          v-text="$t('step-flow-cart-details-takeaway-header')"></h2>
        <h2 class="step-section-header" v-if="cartService.deliveryType.value == 'delivery'"
          v-text="$t('step-flow-cart-details-delivery-header')"></h2>

        <!-- with several methods to choose from the chooser section above shows name and cost -->
        <div class="delivery-method-summary" v-if="isDelivery && applicableDeliveryZones.length == 1 && deliveryMethodName">
          <span class="delivery-method-name" v-text="deliveryMethodName"></span>
          <span class="delivery-method-costs" v-if="deliveryMethodCosts !== null">{{ deliveryMethodCosts.toFixed(2)
            }}<span class="currency-symbol" v-text="currencySymbol"></span></span>
        </div>

        <ion-radio-group v-model="cartService.pickupTimeMode.value"
          :aria-label="cartService.deliveryType.value == 'delivery' ? $t('step-flow-cart-details-delivery-header') : $t('step-flow-cart-details-takeaway-header')">

          <ion-item :lines="showCustomPickupTimeSelector ? 'full' : 'none'"
            :disabled="!firstAllowedPickupOrDeliveryDate">

            <ion-radio mode="md" slot="start"
              :disabled="!firstAllowedPickupOrDeliveryDate || (isDelivery && !deliveryIsPossible)"
              value="assoonaspossible" label-placement="end" :alignment="'center'" justify="start"
              v-text="$t('step-flow-cart-details-takeaway-time-assoonaspossible-label') + (durationInMinutes > 0 ? ` ( ${$t(cartService.deliveryType.value == 'delivery' ? 'checkout-details-delivery-expect-in' : 'checkout-details-pickup-ready-in')} ${manufacturingTimeLabel} )` : '')"></ion-radio>

          </ion-item>

          <ion-item lines="full" v-if="showCustomPickupTimeSelector">
            <ion-radio mode="md" slot="start" value="custom" label-placement="end" :alignment="'center'" justify="start"
              :disabled="isDelivery && !deliveryIsPossible">
              <span v-text="$t('step-flow-cart-details-takeaway-time-custom-label')"></span>
              <span class="selected-pickup-date" v-if="cartService.pickupTimeMode.value == 'custom'"
                v-text="formattedPickupTime"></span>
              <span class="validation-errors" role="alert" v-if="errors && errors.pickupTime">
                <span class="validation-error" v-for="error of errors.pickupTime" v-text="error" :key="error"></span>
              </span>
            </ion-radio>
          </ion-item>
        </ion-radio-group>

        <div class="custom-pickup--time" v-if="cartService.pickupTimeMode.value == 'custom'">
          <oido-slotted-date-picker v-model="cartService.pickupTime.value"
            :disabled="isDelivery && !deliveryIsPossible"></oido-slotted-date-picker>
        </div>


      </section>




      <ion-item lines="full" v-if="pointofsale.enableGeneralNote">

        <ion-textarea class="note" :label="$t('step-flow-cart-details-note-label')" label-placement="floating"
          v-model="cartService.note.value"></ion-textarea>

      </ion-item>
    </div>

    <div class="checkout-flow-item-footer">
      <div class="flow-navigation-buttons">
        <ion-button class="back-button" color="medium" expand="block" @click="gotoPreviousStep"
          :size="frameWidth < 350 ? 'small' : 'default'">
          <ion-icon slot="start" :icon="chevronBackOutline"></ion-icon>
          <span class="label">{{ $t("step-flow-back-button-label") }}</span>
        </ion-button>
        <ion-button class="next-button" :disabled="totalNumberOfItems == 0" expand="block" @click="gotoNextStep"
          :size="frameWidth < 350 ? 'small' : 'default'">
          <ion-spinner v-if="validating" slot="icon-only"></ion-spinner>
          <span class="label">{{ $t("step-flow-next-button-label") }}</span>
          <ion-icon slot="end" :icon="chevronForwardOutline"></ion-icon>
        </ion-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  IonButton,
  IonIcon,
  IonRadio,
  IonRadioGroup,
  IonLabel,
  IonItem,
  IonListHeader,
  IonTextarea,
  IonInput,
  IonCheckbox,
  IonSpinner
} from "@ionic/vue";
import { chevronBackOutline, chevronForwardOutline } from "ionicons/icons";
import dayjs from "dayjs";
import OidoPhoneInput from "../components/OidoPhoneInput.vue";
import OidoSlottedDatePicker from "../components/OidoSlottedDatePicker.vue"
import Validator from "validatorjs";
import parsePhoneNumber from 'libphonenumber-js'
import OidoAddressInput from "../components/OidoAddressInput.vue";
import DeliveryUpgradeHint from "./DeliveryUpgradeHint.vue";
import axios from "axios";
import config from "../../config"
import typedSystem from "../composables/typedSystem"
import cartService from "../composables/cartService"

</script>

<script>

export default {
  props: ['step'],
  data() {
    return {
      validating: false,
      errors: {}
    }
  },
  watch: {
    $route: function () {
      this.cleanupState()
    },
    pickupTimeMode: function () {
      //clear pickuptime when we switch to as soon as possible
      if (this.pickupTimeMode == 'assoonaspossible') {
        cartService.pickupTime.value = null
      }
    },
    deliveryType: function () {
      //clear pickuptime when we change delivery type      
      cartService.pickupTime.value = null
      cartService.pickupTimeMode.value = 'assoonaspossible'
    },
    formattedPickupTime() {
      this.errors.pickupTime = null
    },
    firstAllowedPickupOrDeliveryDate() {
      this.cleanupState()
    },
    needsBillingAddress() {


    },
    userSuppliesBillingAddress(newValue, oldValue) {
      //in case the user supplied a delivery address before adding the billing address
      //set the deliveryUsesDifferentAddress Checkbox so it doesn't get hidden/lost

      let addressHasSomeInput = (address) => {
        if (!address) return false
        if (address.name && address.name.length > 0) return true
        if (address.street && address.street.length > 0) return true
        if (address.city && address.city.length > 0) return true
        if (address.zip && address.zip.length > 0) return true
        if (address.vatId && address.vatId.length > 0) return true
        if (address.countryCode && address.countryCode.length > 0) return true
        return false
      }

      if (newValue && addressHasSomeInput(cartService.deliveryAddress.value)) {
        cartService.deliveryUsesDifferentAddress.value = true
      }
    }
  },
  computed: {
    shouldCollectAnEmailAdress(){
      //if we have a logged-in customer we don't need it
      if(this.customer){
        return false
      }
      return this.pointofsale && this.pointofsale.collectEmail
    },
    cartBreakdown() {
      if (typedSystem.orderCalculator && typedSystem.orderCalculator.value) {
        return typedSystem.orderCalculator.value.getCartBreakDown()
      }
    },
    applicableDeliveryZone() {
      if (typedSystem.orderCalculator && typedSystem.orderCalculator.value) {
        return typedSystem.orderCalculator.value.getApplicableDeliveryZone()
      }
    },
    //every delivery zone which could serve the entered address (with its price for this cart)
    applicableDeliveryZones() {
      if (!this.isDelivery || !typedSystem.orderCalculator || !typedSystem.orderCalculator.value) {
        return []
      }
      return typedSystem.orderCalculator.value.getApplicableDeliveryZones()
    },
    //the effectively used zone: the user's choice when applicable, the cheapest otherwise
    selectedDeliveryZoneId() {
      return this.applicableDeliveryZone && this.applicableDeliveryZone.zone ? this.applicableDeliveryZone.zone.id : null
    },
    pickupLocations() {
      if (!this.isPickup || !typedSystem.orderCalculator || !typedSystem.orderCalculator.value) {
        return []
      }
      return typedSystem.orderCalculator.value.getPickupLocations()
    },
    //the effectively used location: the user's choice when it exists, the first one otherwise
    chosenPickupLocation() {
      if (!typedSystem.orderCalculator || !typedSystem.orderCalculator.value) {
        return null
      }
      return typedSystem.orderCalculator.value.getChosenPickupLocation()
    },
    selectedPickupLocationId() {
      return this.chosenPickupLocation ? this.chosenPickupLocation.id : null
    },
    userSuppliesBillingAddress() {
      return cartService.userSuppliesBillingAddress ? cartService.userSuppliesBillingAddress.value : false
    },
    deliveryUsesDifferentAddress() {
      return cartService.deliveryUsesDifferentAddress ? cartService.deliveryUsesDifferentAddress.value : false
    },
    pickupTimeMode() {
      return cartService.pickupTimeMode ? cartService.pickupTimeMode.value : 'assoonaspossible'
    },
    formattedPickupTime() {
      let pickupTime = cartService.pickupTime ? cartService.pickupTime.value : null
      if (!pickupTime) {
        return ''
      }
      return dayjs(pickupTime).format('DD. MM. YYYY HH:mm')
    },
    firstAllowedPickupOrDeliveryDate() {
      return cartService.firstAllowedPickupOrDeliveryDate.value
    },
    selectedPickupDate() {
      return cartService.pickupTime.value
    },
    durationInMinutes() {
      return this.firstAllowedPickupOrDeliveryDate ? this.firstAllowedPickupOrDeliveryDate.diff(dayjs(), 'minutes')  : null
    },
    manufacturingTimeLabel() {
      if (!this.durationInMinutes) {
        return ''
      }
      let durationInMinutes = Number.parseInt(JSON.parse(JSON.stringify(this.durationInMinutes)) )

      let maximumToDisplayMinutes = 48 * 60
      let minutesShouldBeDisplayed = this.durationInMinutes <= maximumToDisplayMinutes

      // if no minutes are displayed the hours are rounded 
      if (!minutesShouldBeDisplayed) {
          durationInMinutes = Math.round(durationInMinutes/60) * 60
      }


      console.log('durationInMinutes',durationInMinutes)
      if (durationInMinutes < 240 * 60) {
        let label = ''
        let days = Math.floor(durationInMinutes / (24 * 60))
        let hours = Math.floor(durationInMinutes / 60) % 24
        let minutes = Math.floor(durationInMinutes % 60)

        if (days > 0) {
          label = label + days + ' ' + (days == 1 ? this.$t('order-item-manufacturing-time-day') : this.$t('order-item-manufacturing-time-days')) + ' '
        }
        if (hours > 0) {
          label = label + hours + ' ' + (hours == 1 ? this.$t('order-item-manufacturing-time-hour') : this.$t('order-item-manufacturing-time-hours')) + ' '
        }
        if (minutes > 0 && minutesShouldBeDisplayed) {
          label = label + minutes + ' ' + (minutes == 1 ? this.$t('order-item-manufacturing-time-minute') : this.$t('order-item-manufacturing-time-minutes')) + ' '
        }

        if(!minutesShouldBeDisplayed){
          label = this.$t('approximately-prefix') + ' ' + label
        }
        return label
      }

      return this.$t('approximately-prefix') + ' ' + Math.round(durationInMinutes / (24 * 60)) + ' ' + this.$t('order-item-manufacturing-time-days')
    },
    deliveryType() {
      return cartService.deliveryType ? cartService.deliveryType.value : null
    },
    orderOptionsNotice() {
      let notice = null

      if (this.pointofsale && this.pointofsale.orderOptionsNotice) {
        notice = this.pointofsale.orderOptionsNotice
      }
      if (this.customer && this.customer.orderOptionsNotice) {
        notice = this.customer.orderOptionsNotice
      }

      if (notice) {
        let text = this.services.translations.translation2Text(notice);
        let unwantedEndings = ["<p>", '<p>.', '<p>.</p>', '<p></p><p></p>', '<p></p>'];
        for (let unwantedEnding of unwantedEndings) {
          if ((text).endsWith(unwantedEnding)) {
            text = text.substring(0, text.length - text.length)
          }
        }
        return text && text.length > 0 ? text.replace(/(?:\r\n|\r|\n)/g, '<br>') : null;
      }

      return null
    },
    totalNumberOfItems() {
      return cartService.totalNumberOfItems();
    },
    pointofsaleId() {
      return this.$route.params["pointofsaleId"] ? this.$route.params["pointofsaleId"] : null;
    },
    showCustomPickupTimeSelector() {
      return this.allowCustomPickupTime || this.allowCustomDeliveryTime
    },
    //the location the customer picks up at decides the time: when it doesn't let them
    //choose one, the date is only shown as this notice
    showFirstPossiblePickupNotice() {
      return Boolean(this.isPickup && this.chosenPickupLocation && !this.allowCustomPickupTime && this.firstPossiblePickupDateLabel)
    },
    firstPossiblePickupDateLabel() {
      if (!this.firstAllowedPickupOrDeliveryDate) {
        return ''
      }
      return dayjs(this.firstAllowedPickupOrDeliveryDate).format('DD. MM. YYYY HH:mm')
    },
    //whether the customer may select a pickup time — a property of the chosen pickup location
    allowCustomPickupTime() {
      if (!typedSystem.orderCalculator || !typedSystem.orderCalculator.value) {
        return false
      }
      return typedSystem.orderCalculator.value.allowsCustomPickupTime()
    },
    allowCustomDeliveryTime() {
      return Boolean(
        this.applicableDeliveryZone &&
        this.applicableDeliveryZone.zone &&
        this.applicableDeliveryZone.zone.allowCustomDeliveryTime
      )
    },
    deliveryMethodName() {
      let zone = this.applicableDeliveryZone && this.applicableDeliveryZone.zone ? this.applicableDeliveryZone.zone : null
      if (!zone || !zone.name) {
        return null
      }
      return this.services.translations.translation2Text(zone.name)
    },
    deliveryMethodCosts() {
      let price = this.applicableDeliveryZone ? this.applicableDeliveryZone.price : null
      let parsedPrice = Number.parseFloat(price)
      return price !== null && price !== undefined && !Number.isNaN(parsedPrice) ? parsedPrice : null
    },
    deliveryIsPossible() {
      return Boolean(
        this.applicableDeliveryZone &&
        cartService.deliveryType.value == 'delivery'
      )
    },
    isDelivery() {
      return cartService.deliveryType.value == 'delivery'
    },
    isPickup() {
      return cartService.deliveryType.value == 'takeaway'
    },
    deliveryAddressIsComplete() {
      let deliveryAddressToCheck = cartService.deliveryAddress.value;
      if (!this.needsDeliveryAddress) {
        // console.log('deliveryAddress NOT needsDeliveryAddress')
        deliveryAddressToCheck = cartService.billingAddress.value
      }
      // console.log('deliveryAddressToCheck', deliveryAddressToCheck)
      let validationResult = this.validateAddress(deliveryAddressToCheck, "delivery")
      // console.log('validationResult', validationResult)
      return validationResult.passed
    },
    needsDeliveryAddress() {
      return cartService.needsDeliveryAddress.value
    },
    showBillingAddress() {
      return cartService.needsBillingAddress.value ||

        (
          cartService.userSuppliesBillingAddress.value &&
          cartService.allowedToAddBillingAddress.value
        )
    }
  },
  async mounted() {
    this.cleanupState()
  },
  methods: {
    selectDeliveryZone(zoneId) {
      cartService.deliveryZoneId.value = zoneId
    },
    selectPickupLocation(pickupLocationId) {
      cartService.pickupLocationId.value = pickupLocationId
    },
    locationAddressLabel(pickupLocation) {
      let address = pickupLocation && pickupLocation.address ? pickupLocation.address : null
      if (!address) {
        return null
      }
      let cityLine = [address.zip, address.city].filter(Boolean).join(' ')
      let label = [address.street, cityLine].filter(Boolean).join(', ')
      return label.length > 0 ? label : null
    },
    locationDescription(pickupLocation) {
      if (!pickupLocation || !pickupLocation.description) {
        return null
      }
      let text = this.services.translations.translation2Text(pickupLocation.description)
      return text && text.trim().length > 0 ? text : null
    },
    zonePrice(zoneEntry) {
      let price = Number.parseFloat(zoneEntry.price)
      return zoneEntry.price !== null && zoneEntry.price !== undefined && !Number.isNaN(price) ? price : null
    },
    cleanupState() {
      //a very sloppy action when no possible pickupdate is found
      if (!this.firstAllowedPickupOrDeliveryDate) {
        this.pickupTime = null
        cartService.pickupTimeMode.value = 'custom'
      }

      if (!this.showCustomPickupTimeSelector) {
        cartService.pickupTimeMode.value = 'assoonaspossible'
      }

      //if an old pickup-date is present  which is before the firat possible date , delete it
      if (
        this.selectedPickupDate &&
        dayjs(this.selectedPickupDate).isBefore(dayjs(this.firstAllowedPickupOrDeliveryDate))
      ) {
        cartService.pickupTime.value = null
      }
    },
    gotoPreviousStep() {
      this.$emit("previous");
    },
    validateAddress(address, type) {

      if (!address) {
        address = {}
      }

      let rules = {
        name: "required|min:3",
        street: "required",
        city: "required",
        zip: "required",
        countryCode: "required"
      }

      if (address.isCompany || (address.countryCode == 'ES' && type != "delivery")) {
        rules['vatId'] = "required"
      }


      let data = {
        name: address.name,
        street: address.street,
        city: address.city,
        zip: address.zip,
        countryCode: address.countryCode,
        vatId: address.vatId
      }


      let validation = new Validator(data, rules);
      validation.setAttributeNames({
        name: this.$t("address-input-name-label"),
        street: this.$t("address-input-street-label"),
        city: this.$t("address-input-city-label"),
        zip: this.$t("address-input-zip-label"),
        countryCode: this.$t("address-input-country-label")
      });


      if (validation.fails()) {
        return {
          passed: false,
          errors: validation.errors.errors
        }
      }
      return { passed: true, errors: null }

    },
    async gotoNextStep() {

      this.errors = {}
      this.validating = true
      let rules = {}
      let data = {}
      
      
      if (this.deliveryAddressIsComplete && this.isDelivery && !this.deliveryIsPossible) {        
        this.$nextTick(() => {
          let scrollContainer = this.$refs['scroll-container']
          let firstError = scrollContainer.querySelector('.no-delivery-possible-warning')
          if (firstError) {
            scrollContainer.scrollTo({
              top: firstError.offsetTop - scrollContainer.offsetTop - 30,
              behavior: 'smooth'
            });
          }
        })
        this.validating = false
        return
      }      

      //uae the first possible date for assoonaspossible
      if (cartService.pickupTimeMode.value == 'assoonaspossible') {
        cartService.pickupTime.value = this.firstAllowedPickupOrDeliveryDate
      }

      if (this.company.sendSMSOnOrderReady || this.pointofsale.collectPhoneNumber) {
        rules.phone = "required"
        data.phone = cartService.phone.value ? cartService.phone.value : null
      }

      if (this.pointofsale.collectCustomerName) {
        rules.customerName = "required"
        data.customerName = cartService.customerName.value ? cartService.customerName.value : null
      }
      if (this.shouldCollectAnEmailAdress) {
        rules.email = "required|email"
        data.email = cartService.email.value || null
      }
      
      if (
        this.isPickup && this.pointofsale.enablePickup && cartService.pickupTimeMode.value == 'custom' && this.allowCustomPickupTime
      ) {
        rules.pickupTime = "required"
        data.pickupTime = cartService.pickupTime.value
      }


      let validation = new Validator(data, rules);
      validation.setAttributeNames({
        pickupTime: this.$t("step-flow-cart-details-pickup-time-label"),
        customerName: this.$t("step-flow-cart-details-customer-name-label"),
        email: this.$t("step-flow-cart-details-email-label"),
      });

      if (validation.fails()) {
        this.errors = validation.errors.errors
      }

      if (this.showBillingAddress) {
        let billingAddress = cartService.billingAddress.value
        let validationResult = this.validateAddress(billingAddress)
        if (!validationResult.passed) {
          Object.assign(this.errors, { billingAddress: validationResult.errors })
        }

        //validate vat Id and name if its a company address
        if (billingAddress && billingAddress.isCompany) {
          let { data } = await axios.post(config.apiUrl + "/api/taxes/validateTaxId", billingAddress);

          if (data) {
            if (data.errors && Object.keys(data.errors).length > 0) {
              Object.assign(this.errors, { billingAddress: data.errors })
            }
            if (data.data && data.data.name) {
              billingAddress.name = data.data.name
            }
          }
        }
      }

      console.log('this.needsDeliveryAddress',this.needsDeliveryAddress)
      if (this.needsDeliveryAddress) {
        let validationResult = this.validateAddress(cartService.deliveryAddress.value, "delivery")
        if (!validationResult.passed) {
          Object.assign(this.errors, { deliveryAddress: validationResult.errors })
        }
      }



      if (this.company.sendSMSOnOrderReady || this.pointofsale.collectPhoneNumber) {
        const parsedPhoneNumber = parsePhoneNumber(data.phone)
        if (!parsedPhoneNumber || !parsedPhoneNumber.isPossible() || !parsedPhoneNumber.isValid()) {
          this.errors.phone = [this.$t("step-flow-cart-details-invalid-phone-number-error")]
        }
      }
      console.log('errors', this.errors)
      if (Object.keys(this.errors).length > 0) {
        this.$nextTick(() => {
          let scrollContainer = this.$refs['scroll-container']
          let firstError = scrollContainer.querySelector('.validation-error')
          if (firstError) {
            scrollContainer.scrollTo({
              top: firstError.offsetTop - scrollContainer.offsetTop - 30,
              behavior: 'smooth'
            });
          }
        })
        this.validating = false
        return
      }


      // only for testing the pickup time check before paying
      // cartService.pickupTime.value = dayjs().startOf('day').toDate()

      this.validating = false
      this.$emit("next");
      return;
    },
  },
}
</script>
<style scoped>
ion-radio-group {
  margin-top: 0rem;
  margin-bottom: 2rem;
}

.oido-phone-input {
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  margin-bottom: 1rem;
}

.oido-country-selector {
  margin: 0.5rem 0.1rem 1rem;
}

ion-list-header {
  min-height: auto;
  margin-bottom: 0.3rem;
}

ion-list-header ion-label {
  font-size: 1rem;
  font-weight: 200;

}


.order-options-notice {
  padding-bottom: 1rem;
}

.step-section {
  padding-bottom: 1.5rem;
}

.details-section.takeaway {
  margin-bottom: 1rem;
}

.step-section .step-section-header {
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: 200;
}

.step-section .delivery-method-summary {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.delivery-method-section ion-radio {
  width: 100%;
}

.delivery-method-option {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  width: 100%;
}

.delivery-method-option .delivery-method-costs {
  white-space: nowrap;
}

.pickup-location-option,
.pickup-location-summary {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  width: 100%;
}

.pickup-location-summary {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.pickup-location-option .pickup-location-name,
.pickup-location-summary .pickup-location-name {
  font-weight: 599;
}

.pickup-location-option .pickup-location-address,
.pickup-location-summary .pickup-location-address {
  font-size: 0.85rem;
  color: var(--ion-color-medium);
}

.pickup-location-option .pickup-location-description,
.pickup-location-summary .pickup-location-description {
  font-size: 0.85rem;
  font-style: italic;
}

.first-possible-pickup-notice {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-top: 2.5rem;
  margin-bottom: 2rem;
  font-size: 0.95rem;
  color: var(--ion-color-medium);
  justify-content: center;
}

.first-possible-pickup-notice .value {
  font-weight: 599;
  white-space: nowrap;
}

.step-section .delivery-method-summary .delivery-method-name {
  font-weight: 599;
}

.step-section .delivery-method-summary .delivery-method-costs {
  white-space: nowrap;
}

.note {
  margin-top: 1rem;
}

.oido-slotted-date-picker {
  margin-top: 0rem;
}

.selected-pickup-date {
  font-weight: 599;
  margin-left: 0.5rem;
  color: var(--ion-color-primary)
}

ion-radio .validation-errors,
ion-radio .validation-error {
  display: inline;
}

ion-radio .validation-error {
  font-size: 1rem;
  margin-left: 1rem;
}

.no-delivery-possible-warning {
  padding: 2rem 2rem 4rem;
  color: var(--ion-color-primary);
  font-style: italic;
  text-align: center;

}
</style>
<style>
.checkout-flow-item.order-details .details-section .input-line .validation-errors {
  text-align: left;
  margin-bottom: 0;
}


.delivery-address-input {
  padding-bottom: 0 !important;
  margin-bottom: -1rem !important;
}

.toggle-billing-address {
  margin-bottom: 1rem;
}

.toggle-billing-address+.contact-details {
  padding-top: 0;
  margin-top: -1.5rem;
}
</style>
<style>
.checkout-flow-item.order-details ion-item::part(native) {
  background-color: transparent
}

.checkout-flow-item.order-details .validation-errors {
  text-align: left;
  margin-left: 1rem;
}

.oido-phone-input ion-label {
  padding-left: 1rem !important;
  display: block;
  padding-top: 0.5rem;
  margin-bottom: 1.3rem;
  font-size: 1rem;
  font-weight: 200;
  text-align: center;
}

.checkout-flow-item.order-details .oido-country-selector ion-label {
  padding-left: 1rem;
}

.oido-address-input:first-child,
.oido-address-input:first-child ion-label{
  /* padding-top: 0!important; */
}
</style>